export default __webpack_public_path__ + "static/media/drag_drop.85eee7e8.jpg";